export const productCode = (product) => String(product?.code || '').toUpperCase();

export const isTournamentPro = (product) => productCode(product) === 'TOURNAMENT_PRO';
export const isFreeProduct = (product) => product?.billingType === 'free';
export const isBroadcastPack = (product) => productCode(product).startsWith('BROADCAST_');
export const isAiPack = (product) => productCode(product).startsWith('AI_COMMENTARY_');

export const includedUnits = (product) => Number(product?.price?.includedUnits || product?.metadata?.creditGrants?.[0]?.units || 0);

export const formatPerUnitPrice = (product) => {
  const units = includedUnits(product);
  const amountMinor = Number(product?.price?.amountMinor);
  if (!units || !Number.isFinite(amountMinor)) return '';
  return new Intl.NumberFormat('en-IN', { style: 'currency', currency: product.price.currency, minimumFractionDigits: units === 1 ? 0 : 2, maximumFractionDigits: 2 }).format(amountMinor / 100 / units);
};

export const creditGrantUnits = (product, creditType) => Number((product?.metadata?.creditGrants || []).find((grant) => grant.creditType === creditType)?.units || 0);

export const walletPresentation = (creditType) => ({
  broadcast: { title: 'Streaming matches available', unit: 'matches', explanation: '1 Broadcast credit = streaming for 1 match' },
  ai_commentary: { title: 'AI Commentary matches available', unit: 'matches', explanation: '1 AI credit = AI Commentary for 1 match' },
  promotional: { title: 'Promotional balance', unit: 'promotional credits', explanation: 'Usable on eligible CrickArena purchases. Not withdrawable as cash.' },
}[creditType] || { title: String(creditType || '').replaceAll('_', ' '), unit: 'credits', explanation: '' });

export const ledgerDescription = (entry) => ({
  purchase: 'Included with your purchase', consumption: 'Used for a CrickArena match', promotion: 'Promotional reward',
  refund: 'Refund adjustment', admin_grant: 'Granted by CrickArena support', expiry: 'Expired allocation', adjustment: 'Balance adjustment',
}[entry?.entryType] || String(entry?.entryType || 'Wallet activity').replaceAll('_', ' '));

export const contextualUpgradeTitle = (feature, tournamentName) => {
  const name = String(tournamentName || '').trim();
  const title = ({
    'auction.online': 'Run a professional online auction',
    'scheduler.advanced': 'Build an advanced tournament schedule',
    'streaming.premium': 'Stream this match with professional graphics',
    'ai.commentary': 'Add live AI Commentary',
  })[feature?.key] || feature?.upgradeTitle || feature?.displayName;
  return feature?.badgeType === 'TOURNAMENT' && name ? `${title} for ${name}` : title;
};

export const contextualBenefits = (feature, offer) => {
  if (!isTournamentPro(offer)) return (feature?.upgradeBenefits || []).slice(0, 3);
  const broadcast = creditGrantUnits(offer, 'broadcast');
  const ai = creditGrantUnits(offer, 'ai_commentary');
  return [
    ...(feature?.upgradeBenefits || []).slice(0, 1),
    broadcast ? `${broadcast} streamed ${broadcast === 1 ? 'match' : 'matches'} included` : null,
    ai ? `AI Commentary for ${ai} ${ai === 1 ? 'match' : 'matches'} included` : null,
  ].filter(Boolean).slice(0, 3);
};

export const checkoutScope = (product, tournamentName) => isTournamentPro(product)
  ? { tournament: tournamentName || 'Select a tournament', license: 'One tournament' }
  : { tournament: tournamentName || 'Not tournament-specific', license: `${includedUnits(product) || 1} match ${includedUnits(product) === 1 ? 'credit' : 'credits'}` };
